import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

export default function CrearContrasena() {
  const [telefono, setTelefono] = useState('');
  const [contrasena, setContrasena] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/auth/crear-contrasena', { telefono, contrasena });
      alert('Contraseña creada con éxito. Ya puedes iniciar sesión.');
      navigate('/login');
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.mensaje || 'Error al crear la contraseña');
    }
  };

  return (
    <div>
      <h2>Crear contraseña</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Teléfono"
          value={telefono}
          onChange={(e) => setTelefono(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Nueva contraseña"
          value={contrasena}
          onChange={(e) => setContrasena(e.target.value)}
          required
        />
        <button type="submit">Establecer contraseña</button>
      </form>
    </div>
  );
}
